// import 'babel-polyfill'
import 'react-app-polyfill/ie11'

import React from 'react'
import ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'

import { BrowserRouter } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'

import CacheBuster from 'react-cache-buster'
import { version } from '../package.json'
import { Loading } from '@components/shared/elements'

// store
import { Provider } from 'react-redux'
import { rootReducer } from '@store'

import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'


import { HTTP } from '@api/http-common'

import Routes from '@config/router'


import $ from 'jquery'
import 'what-input'
// import '@fortawesome/fontawesome-free/js/all.min.js'; // use it from react-fortawesome
// import '@assets/js/foundation' // waiting this fix release: https://github.com/zurb/foundation-sites/issues/10987
import 'foundation-sites/dist/js/foundation.min'

import 'swiper/dist/css/swiper.min.css'

import '@assets/styles/general.scss'

window.$ = $

const isProduction = process.env.NODE_ENV === 'production'

const storeClient = createStore(
    rootReducer,
    window.INITIAL_STATE,
    compose(
        applyMiddleware(thunk.withExtraArgument({ api: HTTP })),
        // window.devToolsExtension ? window.devToolsExtension() : f => f
        window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
)

ReactDOM.render(

  <CacheBuster
    currentVersion={version}
    isEnabled={isProduction}
    isVerboseMode={false}
    loadingComponent={<Loading />}
  >

    <Provider store={storeClient}>
      <BrowserRouter>
        <React.Suspense fallback={<Loading />}>
          {renderRoutes(Routes)}
        </React.Suspense>
      </BrowserRouter>
    </Provider>

  </CacheBuster>

, document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js